export default __webpack_public_path__ + "static/media/luiksluitingD.jpg";